import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import CandidateForm from "../components/CandidateForm";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

const EditRegistration = forwardRef((props, ref) => {
  const [active, setActive] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [currentStudent, setCurrentStudent] = useState({
    id: "",
    lastname: "",
    firstname: "",
    gender: "",
    birthday: "",
    postal_code: "",
    authorized_back_alone: false,
    authorized_back_with: "",
    authorized_take_photo: false,
    health_issues: "",
    medical_traitement: "",
    allergies: "",
    medical_devices: "",
    parents_divorced: false,
    registration_details: "",
    accepted_internal_rules: true,
  });
  const toast = useRef(null);
  //
  useImperativeHandle(ref, () => ({
    show: (student, message, severity) => {
      setActive(true);
      setCurrentStudent({ ...student });
      setMessage(message);
      setSeverity(severity);
    }
  }));

  const handleSubmit = () => {
    setActive(false);
    props.callbackHandler?.(currentStudent);
  };

  const handleDelete = () => {

    confirmDialog({
      message: 'Voulez-vous vraiment supprimer ce dossier de candidature ?',
      header: 'Confirmation de suppression',
      icon: 'pi pi-info-circle',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Supprimer',
      rejectLabel: 'Annuler',
      accept: () => {
        props.onDelete?.(currentStudent);
        setActive(false);
      },
    });
  };

  return (
    <>
      <Dialog
        header="Mettre à jour le dossier"
        focusOnShow={false}
        visible={active}
        onHide={() => setActive(false)}
        maximizable
        modal
        style={{ width: '90vw', height: '90vh' }}
        footer={
          <div className="flex justify-content-between">
            {currentStudent?.status === "NEW" && <Button label="Supprimer le dossier" className="p-button-danger" icon="pi pi-trash" onClick={handleDelete} /> || <div />}
            <Button label="Enregistrer le dossier" disabled={!currentStudent?.lastname || !currentStudent?.firstname || !currentStudent?.gender || !currentStudent?.birthday } icon="pi pi-save" onClick={handleSubmit} />
          </div>
        }
      >
        <ConfirmDialog />
        {message && <div>
          <Message severity={severity} text={message} className="mt-3" />
        </div>}
        <CandidateForm student={currentStudent} setStudent={setCurrentStudent} father={props?.father} mother={props?.mother} school={props?.school} training={props?.training} />
      </Dialog >
    </>
  );
});

export default EditRegistration;